import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faCheck, faTimes} from "@fortawesome/free-solid-svg-icons";
import {ReactUtilities} from "../../../utilities/react/ReactUtilities";
import {SpinnerButton} from "../../SpinnerButton";
library.add(faTimes);
library.add(faCheck);

    export class Footer extends React.Component<FooterProps, FooterState> {
        static defaultProps: Partial<FooterProps> = {
            CancelButtonText:'Cancel',
            CancelButtonIcon:<FontAwesomeIcon icon={"times"}/>,
            ApplyButtonText:'Apply',
            ApplyButtonIcon:<FontAwesomeIcon icon={"check"}/>,
            IsBusy:false
        };

        constructor(props: FooterProps, context?: any) {
            super(props, context);
            this.state = {};
        }

        public render() {
            return (
                <div className={'rnFooter'} style={{display:'flex',justifyContent:'flex-end'}}>
                    {this.GetFooterArea()}
                </div>
            )
        }

        public GetFooterArea(){
            if(this.props.FooterArea==null)
            return(
                <React.Fragment>
                {this.props.EnableCancel
                &&<button onClick={()=>ReactUtilities.ExecuteMethodPropIfDefined(this.props.OnCancel)} className={'rnbtn rnbtn-danger'}>{this.props.CancelButtonIcon} {this.props.CancelButtonText}</button>}
                    {this.props.EnableApply &&
                    <SpinnerButton IsBusy={this.props.IsBusy} Icon={this.props.ApplyButtonIcon}
                                   OnClick={() => ReactUtilities.ExecuteMethodPropIfDefined(this.props.OnApply)}
                                   className={'rnbtn rnbtn-success'}>{this.props.ApplyButtonText}</SpinnerButton>
                    }
                </React.Fragment>
            );

            return this.props.FooterArea;
        }
    }



//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FooterProps {
    CancelButtonText?:string;
    CancelButtonIcon?:any;
    EnableCancel:boolean;
    EnableApply?:boolean;
    FooterArea:JSX.Element

    IsBusy:boolean;
    ApplyButtonText?:string;
    ApplyButtonIcon?:any;
    OnApply?:()=>any;
    OnCancel?:()=>any;
}

interface FooterState {

}


//#endregion "My Region"